/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useEffect, useRef, useState } from "react";
import { Row, Col, DatePicker, Select, Form } from "antd";
// const { RangePicker } = DatePicker;
const Filters = ({
  children,
  getDepartMentQA,
  clientList,
  setClientDepartment,
  department,
  form,
  bookingType = "account",
  handleClearSelect = () => {},
  selectedClient,
}) => {
  const currentEnv = process.env.REACT_APP_ENV;

  const selectRef = useRef(null);

  useEffect(() => {
    if (selectedClient?.client?.value) {
      form.setFieldsValue({
        client: selectedClient?.client?.value,
        department: selectedClient?.department,
      });
    }
  }, [selectedClient]);

  return (
    <Form form={form}>
      <Row className="row-one align-center" gutter={16}>
        <div style={{ margin: " 0 4px " }}>{children}</div>
        {bookingType == "account" ? (
          <>
            <div>
              <Form.Item name="client">
                <Select
                  ref={selectRef}
                  allowClear
                  onClear={() => handleClearSelect("client")}
                  popupClassName="view-booking-clients-dropDown"
                  style={{ width: "140px" }}
                  placeholder="Select client"
                  showSearch
                  onSelect={(value, obj) => {
                    if (currentEnv == "qa") {
                      getDepartMentQA(obj);
                    } else {
                      setClientDepartment(obj);
                    }
                  }}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  // value={selectedClient?.value}

                  defaultActiveFirstOption
                  options={clientList}
                ></Select>
              </Form.Item>
            </div>
            <div style={{ margin: " 0 4px " }}>
              <Form.Item name="department">
                <Select
                  allowClear
                  onClear={() => handleClearSelect("department")}
                  popupClassName="view-booking-clients-dropDown"
                  style={{ width: "140px" }}
                  // style={{ width: "95%" }}
                  showAction={["focus", "click"]}
                  placeholder="Select department"
                  options={department}
                  onSelect={(value, obj) => {
                    setClientDepartment(null, obj);
                  }}
                ></Select>
              </Form.Item>
            </div>
          </>
        ) : null}
      </Row>
    </Form>
  );
};
export default Filters;
